import React, { useCallback } from 'react';

import { Autocorrection } from '@atlassian/product-search-dialog';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { useSearchInputContext } from '../../SearchInputProvider.tsx';
import { useSearchResultsContext } from '../../SearchResultsProvider.tsx';

import { AutocorrectPlaceholder, AutocorrectWrapper } from './styled.tsx';

export const AutocorrectionWrapper = ({ children }: React.PropsWithChildren<{}>) => (
	<AutocorrectWrapper data-testid="autocorrect-wrapper">{children}</AutocorrectWrapper>
);

export const AutocorrectionComponent = () => {
	const { cloudId } = useSessionData();
	const { searchQuery, onSearchQueryChange } = useSearchInputContext();
	const { loading, results, searchSessionId } = useSearchResultsContext();

	const onCorrectionClick = useCallback(
		(correction: string) => {
			onSearchQueryChange(correction);
		},
		[onSearchQueryChange],
	);

	return !!searchQuery && (!loading || results.length > 0) ? (
		<Autocorrection
			query={searchQuery}
			onCorrectionSelect={onCorrectionClick}
			cloudId={cloudId}
			searchSessionId={searchSessionId}
			source="advancedSearch"
			productId="confluence"
			container={AutocorrectionWrapper}
			noCorrectionPlaceholder={<AutocorrectPlaceholder />}
		/>
	) : (
		<AutocorrectPlaceholder data-testid="autocorrect-placeholder" />
	);
};
